<template>
    <transition name="fade">
        <div class="modal" :class="{'show':modal_show}" tabindex="-1" aria-hidden="true" v-if="modal_show">
            <div class="modal-dialog modal-fullscreen" :class="{'loading':loading}">
                <div class="modal-content">
                    <div class="modal-header">
                        <h5 class="modal-title">{{title}} Content</h5>
                        <button type="button" class="btn btn-round close" @click="close">
                            <i class="mdi mdi-close"></i>
                        </button>
                    </div>
                    <div class="modal-body p-0 d-flex flex-column">
                        <div class="form-group m-0 p-3">
                            <label class="fw-700 text-dark opacity-8 mb-2">Title</label>
                            <input type="text" class="form-control fs-14 form-control-lg custom-input" ref="title" :value="(data.hasOwnProperty.call(data, 'data') ? data.data.title : '')" />
                        </div>

                        <div class="form-group m-0 flex-1">
                            <vue-editor :editor-toolbar="customToolbar" ref="content" style="height: 100%;">
                            </vue-editor>
                        </div>
                        <!-- <div class="p-2">
                            <div class='tag-input'>
                                <div v-for='(tag, index) in tags' :key='index' class='tag-input__tag'>
                                <span @click='removeTag(index)'>x</span>
                                {{ tag }}
                                </div>
                                <input
                                type='text' 
                                    placeholder="Enter a Tag" 
                                    class='tag-input__text' 
                                    @keydown.enter='addTag' 
                                    @keydown.tab='addTag' 
                                    @keydown.delete='removeLastTag'/>
                            </div>
                        </div> -->
                    </div>
                    <div class="modal-footer">
                        <button type="button" class="btn text-primary" @click="exec">{{title}}</button>
                        <button type="button" class="btn" @click="close">Close</button>
                    </div>
                </div>
            </div>
        </div>
    </transition>
</template>

<script>
import { VueEditor } from "vue3-editor";

export default {
    components: {
        VueEditor,
    },
    data() {
        return {
            tags: ['hello', 'world'],
            customToolbar: [
                [{ 'font': [] }, { 'size': [] }],
                ["bold", "italic", "underline", "strike"],
                [{ 'color': [] }],
                [{ 'header': '1' }, { 'header': '2' }, 'blockquote'],
                [{ 'list': 'ordered' }, { 'list': 'bullet'}],
                [{ 'align': ''}, { 'align': 'center'}, {'align': 'right'}],
                [ 'link' ],
                [ 'pdf' ],
                [ 'image' ],
                [ 'clean' ]
            ],
            modal_show: false,
            data: '',
            loading: false,
        }
    },
    computed: {
        title() {
            return (this.data.hasOwnProperty.call(this.data, 'data') == '' ? 'Add' : 'Update');
        }
    },
    methods: {
        addTag (event) {
            event.preventDefault()
            var val = event.target.value.trim()
            if (val.length > 0) {
                this.tags.push(val)
                event.target.value = ''
            }
        },
        removeTag (index) {
            this.tags.splice(index, 1)
        },
        removeLastTag(event) {
            if (event.target.value.length === 0) {
                this.removeTag(this.tags.length - 1)
            }
        },
        close() {
            this.modal_show = false;
            this.data = '';
        },
        exec() {
            if(typeof this.data !== 'object') return;
            
            if(this.data.hasOwnProperty.call(this.data, 'callback')) {
                if(typeof this.data.callback === 'function') {
                    let content = this.$refs.content.$el;
                    let container = content.querySelector('.ql-editor');
                    this.data.callback((this.data.hasOwnProperty.call(this.data, 'data') ? this.data.data.index : null), this.$refs.title.value, container.innerHTML);
                    this.close();
                }
            }
        },
        selectPDF() {
            const input = document.createElement('input');
                input.setAttribute('type', 'file');
                input.setAttribute('accept', 'application/pdf');
                input.click();

            input.onchange = async () => {
                const file = input.files[0];
                console.log(file)
                // file type is only image.
                if (/^application\//.test(file.type)) {
                    let toBase64 = await this.convert(file).catch(e => Error(e));
                    if(toBase64 instanceof Error) {
                        this.$jlalert.show(toBase64.message);
                        return;
                    }

                    this.saveFile('pdf', toBase64, (data) => {
                        let iframe = document.createElement('iframe');
                        iframe.setAttribute('src', data);
                        iframe.setAttribute('class', 'ql-video');

                        let content= this.$refs.content.$el;
                        let container = content.querySelector('.ql-editor');
                        container.appendChild(iframe);

                    });
                } else {
                    this.$jlalert.show('File type not allowed');
                }
            };
        },
        selectImage() {
            const input = document.createElement('input');
                input.setAttribute('type', 'file');
                // input.setAttribute('accept', 'image/*');
                input.setAttribute('accept', 'image/png, image/gif, image/jpeg*');

              
                input.click();

            input.onchange = async () => {
                const file = input.files[0];
                // file type is only image.
                if (/^image\//.test(file.type)) {
                    let toBase64 = await this.convert(file).catch(e => Error(e));
                    if(toBase64 instanceof Error) {
                        this.$jlalert.show(toBase64.message);
                        return;
                    }

                    this.saveFile('img', toBase64, (data) => {
                        let iframe = document.createElement('img');
                        iframe.setAttribute('src', data);
                        iframe.setAttribute('class', 'ql-img');

                        let content= this.$refs.content.$el;
                        let container = content.querySelector('.ql-editor');
                        container.appendChild(iframe);

                    });
                } else {
                    this.$jlalert.show('File type not allowed');
                }
            };
        },
        convert(file) {
            return new Promise((resolve, reject) => {
                const reader = new FileReader();
                reader.readAsDataURL(file);
                reader.onload = () => resolve(reader.result);
                reader.onerror = error => reject(error);
            });
        },
        async saveFile(type, file, fn) {
            this.loading = true;
            await this.$axios.post(`/upload/${type}`, this.$qs.stringify({file:file,type:type}))
                    .then((res) => {
                        if(res.status == 200) {
                            if(fn !== undefined) fn.call(this, res.data)
                        }
                        else this.$jlalert.show(res.data, (res.status !== 200));
                    })
                    .catch((err) => {
                        this.$jlalert.show(err);
                        console.log(err)
                    });
            this.loading = false;
        },
    },
    mounted() {
        this.$emitter.on('show_add_vp', (data) => {
            this.modal_show = true;
            if(data !== undefined) {
                this.data = data;
            }
            else this.data = '';
        });

    },
    watch: {
        "modal_show": function(n) {
            if(n) {
                setTimeout(() => {
                    let content= this.$refs.content.$el;
                    let container = content.querySelector('.ql-editor');
                    container.innerHTML = (this.data.hasOwnProperty.call(this.data, 'data') ? this.data.data.content : '');

                    let button = document.querySelector('button.ql-pdf');
                    button.addEventListener('click', () => {
                        this.selectPDF();
                    });

                    let imgbutton = document.querySelector('button.ql-image');
                    imgbutton.addEventListener('click', () => {
                        this.selectImage();
                    });
                }, 500);
            }
        }
    }
}
</script>

<style scoped>
.modal-dialog.loading::before {
    content: "Uploading ";
    background: #00000042;
    width: 100%;
    height: 100%;
    position: absolute;
    display: flex;
    z-index: 99;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    color: #ffffffbf;
    font-weight: 600;
}

.modal::after {
    background: #000;
    content: '';
    width: 100%;
    height: 100%;
    position: fixed;
    top: 0;
    z-index: -1;
    opacity: 0.5;
}

.modal.show {
    display: block;
}

.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.1s ease;
}

.fade-enter-from,
.fade-leave-to {
  opacity: 0;
}


.text-primary {
    color: var(--primary-color) !important;
}
</style>